import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    background: "#00833E",
    color: "#fff",
    width: "110px",
    height: "32px",
    borderRadius: "16px",
  },

  icon_container: {
    cursor: "pointer",
  },
  children_container: {
    maxWidth: "80px",
    overflow: "hidden",
  },
}));

export default useStyles;
